// extracted by mini-css-extract-plugin
module.exports = {"order-history":"OrderHistory_order-history__gnzic","card":"OrderHistory_card__5UDwb","divider":"OrderHistory_divider__jCyER"};